<template>
<!--	<HeaderInfo-->
<!--		type="collection"-->
<!--		:item="event.collection"-->
<!--	/>-->
<!--	<section class="breadcrumbs mb-1d2">-->
<!--		<a href="{% url 'studio:filtering' %}" class="breadcrumbs-link">Studios</a>-->
<!--		<a href="{% url 'collection:filtering' %}" class="breadcrumbs-link">NFT Collections</a>-->
<!--		<span class="breadcrumbs-page">Events</span>-->
<!--	</section>-->

<!--	<section class="data mb-1d2">-->
<!--		<div class="data-wrapper">-->
<!--			{% if object.studio %}-->
<!--			<div class="data-container">-->
<!--				<div class="data__image">-->
<!--					<img src="{{object.studio.logo.url}}" alt="{{object.studio.name}}" class="img img&#45;&#45;cover">-->
<!--				</div>-->
<!--				<div class="data__about">-->
<!--					<p class="body-2">Studio</p>-->
<!--					<a href="{{object.studio.get_absolute_url}}" class="headline-3">{{object.studio.name}}</a>-->
<!--				</div>-->
<!--			</div>-->
<!--			{% endif %}-->

<!--			{% if object.collection %}-->
<!--			<div class="data-container">-->
<!--				<div class="data__image">-->
<!--					<img src="{{object.collection.logo.url}}" alt="{{object.collection.name}}" class="img img&#45;&#45;cover">-->
<!--				</div>-->
<!--				<div class="data__about">-->
<!--					<p class="body-2">NFT Collection</p>-->
<!--					<a href="{{object.collection.get_absolute_url}}" class="headline-3">{{object.collection.name}}</a>-->
<!--				</div>-->
<!--			</div>-->
<!--			{% endif %}-->
<!--		</div>-->
<!--	</section>-->

	<template v-if="event">
		<TaggedInfo
			v-if="event?.studio || event?.collection"
			:studio="event?.studio"
			:collection="event?.collection"
		/>

		<HeaderInfo
			v-if="event"
			:item="event"
			type="event"
		/>

		<section class="tabs">
			<div class="nav">
				<span
					v-for="tab in tabs"
					class="tab-btn nav-item btn-text"
					:class="{ active: tab.name === activeTab, disabled: tab.disabled }"
					@click="activeTab = tab.name, activeComponent = tab.component"
				>
					{{ tab.title }}
				</span>
			</div>

			<div class="tab-list">
				<KeepAlive>
					<component
						:is="activeComponent"
						:item="event"
						type="event"
					/>
				</KeepAlive>
			</div>
		</section>

		<SliderQuarto
			v-if="event?.collections?.length"
			:items="event?.collections"
			title="Collections"
			titleIconClass="icon-grp-10"
		/>

		<EventsRecommended />

		<SliderQuarto
			:items="recentCollections"
			:title="$t('recommendedCollections')"
			titleIconClass="icon-grp-5"
			:subTitle="$t('moreCollections')"
			subTitleLink="/nft/collections"
			class="slider-collection-recommended"
		/>
	</template>

	<div v-else class="page-error">Event not found</div>
</template>

<script>
import TabInterviews from '@/components/personal-about-page/TabInterviews.vue'
import TabDetails from '@/components/personal-about-page/TabDetails.vue'
import TabComplaints from '@/components/personal-about-page/TabComplaints.vue'
import TabFeedback from '@/components/personal-about-page/TabFeedback.vue'
import TabNews from '@/components/personal-about-page/TabNews.vue'
import {useApi} from '~/composables/api';

export default defineNuxtComponent({
	name: 'PageEvent',
	components: {
		TabInterviews,
		TabDetails,
		TabComplaints,
		TabFeedback,
		TabNews
	},
	async setup() {
        // console.log('p:event setup()')
		definePageMeta({
			middleware: ['entities'],
		})

        const api = useApi();
        const route = useRoute();
		const app = useNuxtApp();
		let event = null;
		let response = null;
		let recentCollections = [];

        // console.log('p:event route', route.params)
		try {
	        response = await api.events.fetchEventBySlug(route.params.event);
		} catch (e) {
			console.log('Event not found');
		}

		if (response?.metadata) {
			event = response.result;

			useSeoMeta({
				title: response.metadata.title,
				ogTitle: response.metadata.title,
				description: response.metadata.description,
				ogDescription: response.metadata.description,
				ogImage: app.$config.public.HOST_BACKEND + (response.result?.logo?.url ?? response.result?.collection?.logo?.url),
			});

			if (response.metadata?.alternates) {
				const arrAlternatives = [];

				for (const lang in response.metadata.alternates) {
					arrAlternatives.push({
						rel: 'alternate',
						hreflang: lang,
						href: response.metadata.alternates[lang]
					})
				}
				arrAlternatives.push({
					rel: 'alternate',
					hreflang: 'x-default',
					href: response.metadata.alternates['en']
				})

				useHead({
					link: arrAlternatives
				})
			}
		}

		response = await api.collections.fetchRecentCollections();

		if (response?.results?.length) {
			recentCollections = response?.results;
		}

		return {
			event,
			recentCollections
		}
    },
	data() {
		return {
			activeTab: 'details',
			activeComponent: 'TabDetails',
			recentCollections: [],
            tabs: [
				{
					name: 'details',
					title: this.$t('details'),
					component: 'TabDetails'
				},
				{
					name: 'complaints',
					title: this.$t('complaints'),
					component: 'TabComplaints',
					disabled: true
				},
				{
					name: 'feedback',
					title: this.$t('feedback'),
					component: 'TabFeedback',
					disabled: true
				},
			],
		}
	},
})
</script>
